import Link from 'next/link';
import React from 'react';
import { IoHammerOutline, IoPieChartOutline, IoTvOutline } from 'react-icons/io5';

import { Menu } from '@mantine/core';
import { openContextModal } from '@mantine/modals';

import { IS_TOUCH_LOCAL_STORAGE_KEY } from 'helpers/isTouchDevice';

import { useCurrentUser } from 'hooks/use-current-user';
import { LocalStorageService } from 'services/LocalStorageService';

const AdminZone = () => {
    const user = useCurrentUser();

    if (!user?.developer) {
        return null;
    }

    const showDeviceTypeModal = () => {
        openContextModal({
            modal: 'deviceType',
            innerProps: {},
            withCloseButton: false,
        });
    };

    const savedDeviceType = LocalStorageService.get(IS_TOUCH_LOCAL_STORAGE_KEY);

    return (
        <>
            <Menu.Divider />
            <Menu.Label bg="blue.0">
                ⚠️ Admin zone <br /> (Only visible for developers)
            </Menu.Label>
            <Menu.Item component={Link} href="/admin-area" bg="blue.0" leftSection={<IoPieChartOutline size={14} />}>
                Statistics & Analytics
            </Menu.Item>
            <Menu.Item component={Link} href="/admin-area" bg="blue.0" leftSection={<IoHammerOutline size={14} />}>
                Tools
            </Menu.Item>
            <Menu.Item bg="blue.0" leftSection={<IoTvOutline size={14} />} onClick={showDeviceTypeModal}>
                Set device type (current: {savedDeviceType ?? 'N/A'})
            </Menu.Item>
        </>
    );
};

export { AdminZone };
